import { UpdateEprUinArgs } from 'types/api/arguments/update-epr-uin-args'

import { api } from './api'

export const updateEprUin = ({ uinId, uinNumber }: UpdateEprUinArgs) =>
  api.put(`/business_accounts/epr_uins/${uinId}`, {
    epr_uin: {
      uin: uinNumber,
    },
  })
